import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function ContactPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="contact" />

      {/* ===== HERO ===== */}
      <PageHero className="pageHero">
        <div className="container textCenter">
          <h1 className="font60 extraBold darkColor heroTitle" style={{ lineHeight: "1.1" }}>
            צרי קשר 💌
          </h1>
          <p className="font18 darkColor" style={{ marginTop: "20px", lineHeight: "1.7" }}>
            שמחה מאוד לשמוע ממך: שאלה, בקשה, סתם היי.
          </p>
          {/* IMAGE PLACEHOLDER — decorative hero strip image */}
          <HeroImgStrip>
            <HeroImgPlaceholder>
              <span>📸 תמונה אווירתית: ליצירת קשר</span>
            </HeroImgPlaceholder>
          </HeroImgStrip>
        </div>
      </PageHero>

      {/* ===== CONTACT FORM ===== */}
      <Section className="lightBg">
        <div className="container">
          <ContactGrid>
            <FormSide>
              <h2 className="font30 extraBold darkColor" style={{ marginBottom: "30px" }}>
                כתבי לי 📝
              </h2>
              <ContactForm>
                <FormGroup>
                  <FormLabel className="font13 semiBold">שם:</FormLabel>
                  <FormInput type="text" name="name" placeholder="השם שלך" />
                </FormGroup>
                <FormGroup>
                  <FormLabel className="font13 semiBold">אימייל:</FormLabel>
                  <FormInput type="email" name="email" placeholder="האימייל שלך" />
                </FormGroup>
                <FormGroup>
                  <FormLabel className="font13 semiBold">נושא:</FormLabel>
                  <FormInput type="text" name="subject" placeholder="נושא ההודעה" />
                </FormGroup>
                <FormGroup>
                  <FormLabel className="font13 semiBold">הודעה:</FormLabel>
                  <FormTextarea rows="6" name="message" placeholder="מה על ליבך?" />
                </FormGroup>
                <SubmitBtn className="pinkBg whiteColor radius8 pointer semiBold font15">
                  שלחי הודעה ✉️
                </SubmitBtn>
              </ContactForm>
            </FormSide>

            <ImageSide>
              {/* IMAGE PLACEHOLDER — main contact image (tall) */}
              <ContactImgMain className="radius8" style={{ background: "var(--tint-rose)" }}>
                <span>📸 תמונה ראשית: יצירת קשר</span>
              </ContactImgMain>
              <ContactImgRow>
                {/* IMAGE PLACEHOLDER — second small contact photo */}
                <ContactImgSmall className="radius8" style={{ background: "var(--tint-butter)" }}>
                  <span>📸 תמונה 2</span>
                </ContactImgSmall>
                {/* IMAGE PLACEHOLDER — third small contact photo */}
                <ContactImgSmall className="radius8" style={{ background: "var(--tint-rose)" }}>
                  <span>📸 תמונה 3</span>
                </ContactImgSmall>
              </ContactImgRow>
            </ImageSide>
          </ContactGrid>
        </div>
      </Section>

      {/* ===== CONTACT DETAILS ===== */}
      <Section>
        <div className="container">
          <SectionHeader>
            <h2 className="font30 extraBold darkColor">עוד דרכים להגיע 📍</h2>
          </SectionHeader>
          <DetailsGrid className="stagger-reveal">
            <DetailCard className="lightBg radius8">
              {/* IMAGE PLACEHOLDER — email icon or photo */}
              <DetailImgBox style={{ background: "var(--tint-rose)" }}>
                <span>📸 אימייל</span>
              </DetailImgBox>
              <DetailIcon>📧</DetailIcon>
              <h3 className="font18 extraBold darkColor">אימייל</h3>
              {/* TEXT PLACEHOLDER — replace with your real email */}
              <p className="font14 greyColor" style={{ marginTop: "8px" }}>carmela0208@gmail.com</p>
            </DetailCard>

            <DetailCard className="lightBg radius8">
              {/* IMAGE PLACEHOLDER — Instagram or social photo */}
              <DetailImgBox style={{ background: "var(--tint-butter)" }}>
                <span>📸 אינסטגרם</span>
              </DetailImgBox>
              <DetailIcon>📸</DetailIcon>
              <h3 className="font18 extraBold darkColor">אינסטגרם</h3>
              {/* TEXT PLACEHOLDER — replace with your real handle */}
              <p className="font14 greyColor" style={{ marginTop: "8px" }}>@your_handle</p>
            </DetailCard>

            <DetailCard className="lightBg radius8">
              {/* IMAGE PLACEHOLDER — WhatsApp or phone photo */}
              <DetailImgBox style={{ background: "var(--tint-rose)" }}>
                <span>📸 וואטסאפ</span>
              </DetailImgBox>
              <DetailIcon>💬</DetailIcon>
              <h3 className="font18 extraBold darkColor">וואטסאפ</h3>
              {/* TEXT PLACEHOLDER — replace with your real number */}
              <p className="font14 greyColor" style={{ marginTop: "8px" }}>050-000-0000</p>
            </DetailCard>
          </DetailsGrid>
        </div>
      </Section>

      {/* ===== PHOTO STRIP ===== */}
      <PhotoStrip>
        {[
          { bg: "var(--tint-rose)", label: "📸 תמונת סדנה 1" },
          { bg: "var(--tint-butter)", label: "📸 תמונת סדנה 2" },
          { bg: "var(--tint-mauve)", label: "📸 תמונת סדנה 3" },
          { bg: "var(--tint-butter)", label: "📸 תמונת סדנה 4" },
          { bg: "var(--tint-rose)", label: "📸 תמונת סדנה 5" },
        ].map((item, i) => (
          <PhotoItem key={i} style={{ background: item.bg }}>
            <span>{item.label}</span>
          </PhotoItem>
        ))}
      </PhotoStrip>

      {/* ===== CTA ===== */}
      <CTASection className="coralBg">
        <div className="container textCenter">
          <h2 className="font30 extraBold darkColor">רוצה לראות את המוצרים שלנו? 🌟</h2>
          <CTABtns>
            <CTABtn onClick={() => navigate("journal")} className="pinkBg whiteColor radius8">
              יומן ויזואלי
            </CTABtn>
            <CTABtn onClick={() => navigate("cards")} className="darkBg whiteColor radius8">
              קלפי נפש
            </CTABtn>
            <CTABtn onClick={() => navigate("visionboard")} className="pinkBg whiteColor radius8">
              לוח חזון
            </CTABtn>
          </CTABtns>
        </div>
      </CTASection>

      <Footer navigate={navigate} />
    </>
  );
}

/* ---- Styled Components ---- */
const PageHero = styled.section`
  padding: 120px 0 60px;
  direction: rtl;
`;
const HeroImgStrip = styled.div`
  margin-top: 50px;
  height: 180px;
  border-radius: 1rem;
  overflow: hidden;
`;
const HeroImgPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 1rem;
  background: var(--grad-blush);
  color: var(--rose-600);
  border: 8px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-lift);
  animation: float 7s ease-in-out infinite;
`;
const Section = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;
const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: flex-start;
  @media (max-width: 860px) { grid-template-columns: 1fr; }
`;
const FormSide = styled.div``;
const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
const FormLabel = styled.label`
  color: var(--ink);
  margin-bottom: 6px;
`;
const FormInput = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 2px solid var(--rose-600);
  height: 38px;
  outline: none;
  font-size: 1rem;
  font-family: inherit;
  direction: rtl;
  padding: 0 4px;
  color: var(--ink);
  &::placeholder { color: var(--ink-muted); }
`;
const FormTextarea = styled.textarea`
  width: 100%;
  background: transparent;
  border: 2px solid var(--rose-600);
  border-radius: 0.5rem;
  outline: none;
  padding: 10px;
  font-size: 1rem;
  font-family: inherit;
  direction: rtl;
  resize: vertical;
  color: var(--ink);
  &::placeholder { color: var(--ink-muted); }
`;
const SubmitBtn = styled.button`
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  max-width: 220px;
  margin-top: 10px;
`;
const ImageSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const ContactImgMain = styled.div`
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
`;
const ContactImgRow = styled.div`
  display: flex;
  gap: 15px;
`;
const ContactImgSmall = styled.div`
  flex: 1;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.813rem;
  font-weight: 600;
  color: var(--ink);
`;
const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  @media (max-width: 700px) { grid-template-columns: 1fr; }
`;
const DetailCard = styled.div`
  padding: 25px;
  text-align: center;
  box-shadow: var(--shadow-card);
  transition: transform 0.6s var(--ease-spring), box-shadow 0.6s var(--ease-out);
  &:hover { transform: translateY(-8px); box-shadow: var(--shadow-lift); }
`;
const DetailImgBox = styled.div`
  height: 120px;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.813rem;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 15px;
`;
const DetailIcon = styled.div`
  font-size: 1.75rem;
  margin-bottom: 8px;
`;
const PhotoStrip = styled.div`
  display: flex;
  height: 180px;
  @media (max-width: 600px) { flex-wrap: wrap; height: auto; }
`;
const PhotoItem = styled.div`
  flex: 1;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--ink);
  @media (max-width: 600px) { flex: 0 0 50%; height: 120px; }
`;
const CTASection = styled.section`
  padding: 70px 0;
  direction: rtl;
`;
const CTABtns = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 25px;
  flex-wrap: wrap;
`;
const CTABtn = styled.button`
  padding: 12px 25px;
  font-size: 0.938rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
`;
